import {localRead, localSave} from '../../utils/util'

import {
  addcustomer,
  addcustomercrop,
  delcustomercrops,
  delecustomers,
  editcustomer,
  editcustomercrop,
  getcustomercropdetail,
  getcustomercroplist,
  getcustomerdetail,
  getcustomerlist,
  getcustomertypelist
} from '../../services/customerapi'

export default {
  state: {
    guideList: [],
    customerstyleList: [],
    selectcustid: localRead('selectcustid') || 0
  },
  mutations: {
    setCustomerStyleList (state, list) {
      state.customerstyleList = list
    },
    setSelectedId (state, id) {
      state.selectcustid = id
      localSave('selectcustid', id)
    },
    setCustomerGuildList (state, guideList) {
      state.guideList = guideList
    }
  },
  actions: {
    handleCustomerGuildList ({commit}, guideList) {
      commit('setCustomerGuildList', guideList)
    },
    handleSelectId ({commit}, customId) {
      commit('setSelectedId', customId)
    },
    getcustomertypelist ({commit}) {
      return getcustomertypelist().then(res => {
        commit('setCustomerStyleList', res.data)
      })
    },
    getcustomerlist (store, params) {
      return getcustomerlist(params)
    },
    addcustomer (store, params) {
      return addcustomer(params)
    },

    getcustomerdetail (store, {customerId}) {
      return getcustomerdetail(customerId)
    },
    delecustomers (store, params) {
      return delecustomers(params)
    },
    editcustomer (store, {customerId, params}) {
      return editcustomer(customerId, params)
    },
    getcustomercroplist (store, params) {
      return getcustomercroplist(params)
    },
    addcustomercrop (store, params) {
      return addcustomercrop(params)
    },
    getcustomercropdetail (store, {relationId, params}) {
      return getcustomercropdetail(relationId, params)
    },
    editcustomercrop (store, {relationId, params}) {
      return editcustomercrop(relationId, params)
    },
    delcustomercrops (store, params) {
      return delcustomercrops(params)
    }
  }
}
